export default __webpack_public_path__ + "static/media/app-bubbles.c7855d26.svg";